<template>
  <div class="video-card" @click="openVideo">
    <AppSkeleton v-if="loading" width="100%" height="165px" />
    <CardMedia v-else class="video-card__preview" :src="preview" height="165">
      <div class="video-card__play-container">
        <VideoPlay class="video-card__play" />
      </div>
    </CardMedia>
    <h3 class="video-card__name">
      <AppSkeleton v-if="loading" width="85%" />
      <span v-else>{{ item.title }}</span>
    </h3>
  </div>
</template>

<script>
import VideoPlay from "./VideoPlay";
import { openModal as openVideoModal } from "./VideoWatch";

export default {
  name: "VideosWidgetItem",
  components: {
    VideoPlay
  },
  props: {
    item: Object
  },
  computed: {
    loading() {
      return !this.item;
    },
    preview() {
      const { item } = this;
      if (!item) return;
      const { first_frame: frameImages, image: images } = item;
      let url = "";
      if (frameImages && frameImages[0]) {
        url = frameImages[0].url;
      } else if (images && images[3]) {
        url = images[3].url;
      }
      return url;
    }
  },
  methods: {
    openVideo() {
      openVideoModal(this.item);
    }
  }
};
</script>

<style lang="scss">
.video-card {
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  &__name {
    @include text-ellipsis();
    width: 100%;
    color: colors(text-2);
    font-size: 17px;
  }

  &__preview {
    height: 165px;
    width: 100%;
    box-shadow: shadow();
    background-color: colors(palette-3);
    position: relative;
    margin-bottom: 8px;
  }

  &__play-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
